export function toTitleCase(text) {
  if (!text) return "";
  return text.toUpperCase();
}